import { Button, CardActions, TextField, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import styled from "styled-components";
import { ReactComponent as Logo } from "../assets/logo.svg";
import CardContent from "@mui/material/CardContent";
import { useForm } from "react-hook-form";
import { userLoginSchema } from "../schemas";
import { useAuth } from "../providers/users";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 100vw;
  height: 100vh;
  animation: opacityOnAndOff 3s normal forwards;

  @keyframes opacityOnAndOff {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;

const LoginForm = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  const history = useHistory();
  const { signIn } = useAuth();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(userLoginSchema) });

  function onLogin(payload) {
    signIn(payload);
    reset();
  }
  return (
    <>
      {isLoading ? (
        <Loader>
          <Logo style={{ width: "200px" }} />
        </Loader>
      ) : (
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            mb: "2rem",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Container
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "center",
              mb: "2rem",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "4rem", md: "8rem" },
                fontWeight: "bold",
                color: "accent.light",
              }}
              color="accent.light"
              align="center"
              fontWeight={800}
            >
              Anthorflix
            </Typography>
            <Logo style={{ maxWidth: "100px", maxHeight: "100px" }} />
          </Container>
          <form onSubmit={handleSubmit(onLogin)}>
            <Card
              sx={{
                width: { xs: "90vw", md: "35vw", lg: "30vw" },
                height: "75vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "background.main",
              }}
              elevation={4}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "85%",
                  flexGrow: 4.5,
                  justifyContent: "space-around",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "3rem",
                    color: "primary.dark",
                    display: "flex",
                    alignItems: "center",
                  }}
                  component="div"
                  gutterBottom
                >
                  Faça seu login{" "}
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "5rem",
                      color: "accent.dark",
                    }}
                  >
                    :)
                  </Typography>
                </Typography>

                <TextField
                  label="Email"
                  placeholder="Digite seu email"
                  fullWidth
                  {...register("email")}
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  size="large"
                />
                <TextField
                  label="Senha"
                  placeholder="Digite sua senha"
                  type="password"
                  {...register("password")}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  size="large"
                />
              </CardContent>
              <CardActions
                sx={{
                  flexGrow: 0.5,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button variant="contained" color="primary" type="submit">
                  ENTRAR
                </Button>
                <Button color="primary" onClick={() => history.push("/signup")}>
                  CADASTRAR
                </Button>
              </CardActions>
            </Card>
          </form>
        </Container>
      )}
    </>
  );
};

export default LoginForm;
